import React from 'react';
import styled from 'styled-components';
import Card from '../components/Card';
import Container from '../components/Container';

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
  background-color: var(--card-bg);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const EmptyIcon = styled.div`
  width: 64px;
  height: 64px;
  margin-bottom: 1.5rem;
  color: var(--text-secondary);
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

const EmptyTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
`;

const EmptyDescription = styled.p`
  font-size: 0.875rem;
  color: var(--text-secondary);
  max-width: 400px;
  margin: 0 auto;
`;

function ReceiptsPage() {
  return (
    <Container>
      <Card>
        <EmptyState>
          <EmptyIcon>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M4 14V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <rect x="3" y="10" width="18" height="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M8 14H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M8 10V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M16 10V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </EmptyIcon>
          <EmptyTitle>No Receipts Available</EmptyTitle>
          <EmptyDescription>
            The receipts feature is currently under development. Check back soon for updates.
          </EmptyDescription>
        </EmptyState>
      </Card>
    </Container>
  );
}

export default ReceiptsPage;